import {
    GuideLinkButton,
    ModalWrapper,
    NewModalBodyWrapper,
    PageHeader,
    useBreadcrumbs,
    useTabs,
} from '@mews-commander/ui';
import { FeatureFlag, ArticlePath, createGuideLink } from '@mews-commander/enums';
import { compactArray } from '@mews/fp';
import { useFeatureFlag } from '@mews/framework';
import { WithChildren } from '@optimus-web/common';
import { useGetAccountingConfigurationOptionsSuspense } from '../../../payment/queries';

const guideLink = createGuideLink(ArticlePath.CityLedger);

export const FinanceLedgersLayout: React.FC<WithChildren> = ({ children }) => {
    const { data: accountingConfigurationOptions } = useGetAccountingConfigurationOptionsSuspense();
    const canLinkInvoicesConfig = Boolean(accountingConfigurationOptions?.receivableTrackingEnabled);

    const breadcrumbs = useBreadcrumbs();
    const goodDadaLedgersEnabled = useFeatureFlag(FeatureFlag.newFinanceLedgersEnabled);
    const depositLedgerTabEnabled = useFeatureFlag(FeatureFlag.newDepositLedger) || goodDadaLedgersEnabled;
    const guestLedgerTabEnabled = useFeatureFlag(FeatureFlag.mewsGuestLedger) || goodDadaLedgersEnabled;
    const cityLedgerTabEnabled = canLinkInvoicesConfig || goodDadaLedgersEnabled;
    const trialBalanceEnabled = useFeatureFlag(FeatureFlag.trialBalanceEnabled);

    const ledgerTabs = useTabs(
        '/$currentEnterpriseId/Finance/Ledgers',
        compactArray([
            depositLedgerTabEnabled ? 'Deposit' : null,
            guestLedgerTabEnabled ? 'Guest' : null,
            cityLedgerTabEnabled ? 'City' : null,
            trialBalanceEnabled ? 'TrialBalance' : null,
        ])
    );
    const actions = cityLedgerTabEnabled ? <GuideLinkButton guideLink={guideLink} /> : undefined;
    return (
        <ModalWrapper>
            <PageHeader tabs={ledgerTabs} breadcrumbs={breadcrumbs} actions={actions} />
            <NewModalBodyWrapper>{children}</NewModalBodyWrapper>
        </ModalWrapper>
    );
};
